<template>
    <div>
        <div class="min-h-screen flex relative lg:static surface-ground">
            <AppSidebar v-model:sidebarShow="sidebarShow" :usuario="usuario" />

            <!-- app-body -->
            <div class="min-h-screen flex flex-column relative flex-auto" style="min-width: 0;">
                <AppHeader
                    :usuario="usuario"
                    :isDarkMode="isDarkMode"
                    @toggle-sidebar="sidebarShow = !sidebarShow"
                    @toggle-theme="toggleDarkMode"
                    @open-profile="visibleProfileForm = true"
                    @open-password="visiblePasswordForm = true"
                    @logout="logout"
                    @tenant-pronto="tenantPronto = true"
                />

                <!-- content -->
                <!-- Nada de rota antes do tenant resolvido (T4.2): página que
                     monta busca dados na hora, e buscar antes da escolha é
                     mostrar o tenant errado. -->
                <div class="app-content flex flex-column flex-auto p-2" :class="{'bg-gray-900': isDarkMode, 'surface-ground': !isDarkMode}">
                    <router-view v-if="tenantPronto" :key="$route.path + '-theme-' + chartRefreshKey"></router-view>
                </div>
                <!-- content -->

                <div class="app-footer mt-auto p-2 text-right text-xs">
                    criado e mantido por <a href="https://gorilash.com.br" class="footer-link">Gorila Software House</a> todos os direitos reservados.
                </div>
            </div>
            <!-- app-body -->
        </div>

        <ProfileForm :visible="visibleProfileForm" :data="usuario" @close="visibleProfileForm=false" @save="onSaveProfileForm" />
        <PasswordForm :visible="visiblePasswordForm" :data="usuario" @close="visiblePasswordForm=false" />
        <NovidadesDialog />
    </div>
</template>

<script>
import AppSidebar from './AppSidebar.vue';
import AppHeader from './AppHeader.vue';
import ProfileForm from '@/components/auth/ProfileForm.vue';
import PasswordForm from '@/components/auth/PasswordForm.vue';
import NovidadesDialog from '@/components/NovidadesDialog.vue';

import Auth from '@/service/auth.js';
import Token from '@/utils/Token.js';

export default {
    components: {
        AppSidebar,
        AppHeader,
        ProfileForm,
        PasswordForm,
        NovidadesDialog,
    },
    data() {
        return {
            isDarkMode: true,
            chartRefreshKey: 0,
            visibleProfileForm: false,
            visiblePasswordForm: false,
            usuario: {},
            sidebarShow: false,
            tenantPronto: false,
        };
    },
    beforeMount() {
        this.loadThemePreference();
        this.me();
    },
    methods: {
        onSaveProfileForm(usuario) {
            this.usuario = usuario;
        },
        loadThemePreference() {
            const saved = localStorage.getItem('gts_theme_dark');
            this.isDarkMode = saved !== '0'; // Defaults to dark mode (true) if not set or not '0'
            this.applyThemeClass();
        },
        applyThemeClass() {
            document.documentElement.classList.toggle('my-app-dark', this.isDarkMode);
            window.dispatchEvent(new Event('theme-changed'));
        },
        toggleDarkMode() {
            this.isDarkMode = !this.isDarkMode;
            localStorage.setItem('gts_theme_dark', this.isDarkMode ? '1' : '0');
            this.applyThemeClass();
            this.chartRefreshKey += 1;
        },
        me() {
            Auth.me()
                .then(response => {
                    this.usuario = response.data;
                })
                .catch(error => {
                    const msg = error.response?.data?.msg || error.message;
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: msg, life: 5000 });
                });
        },
        logout() {
            this.$confirm.require({
                message: 'Deseja realmente sair do sistema?',
                header: 'Sair do Sistema',
                icon: 'pi pi-sign-out',
                acceptLabel: 'Sair',
                acceptClass: 'bg-green-300 text-white',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-400 text-white',
                accept: () => {
                    Auth.logout()
                        .then(() => {
                            Token.remove();
                            this.$toast.add({ severity: 'warn', summary: 'Até logo!', detail: `Você está saindo do sistema.`, life: 3000 });
                            this.$router.push({ name: 'login', replace: true });
                        })
                        .catch(error => {
                            Token.remove();
                            const msg = error.response?.data?.msg || error.message;
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: msg, life: 5000 });
                            this.$router.push({ name: 'login', replace: true });
                        });
                },
            });
        }
    }
};
</script>

<style>
/* Estilos globais mantidos */
</style>

<style>
/* Estilos globais mantidos */
</style>
